let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("e08m0"), load("hG0Zu"), load("kLKm3"), load("6zfzy"), load("6vOHT")]).then(() => parcelRequire('diitp'));